export const updateModalContent = ( modalObj ) => {
  return{
    type: 'SET_MODAL_OVERLAY',
    payload: modalObj
  }
}